import styled from '@emotion/styled';

import GenericButton from 'src/components/GenericButton';

export const Container = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  padding: 16px 12px;
  border-radius: 16px;

  background-color: ${({ theme }) => theme.color.surface2};
  color: ${({ theme }) => theme.color.content12};

  ${({ theme }) => theme.screenSize.desktop} {
    flex-direction: row;
    gap: 16px;

    padding: 12px 24px;
  }
`;

export const ProfileInfo = styled.div`
  width: 100%;
  min-width: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${({ theme }) => theme.screenSize.desktop} {
    flex: 1;

    flex-direction: row;
    gap: 16px;
  }
`;

export const ProfileImageContainer = styled.button`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;

  position: relative;
  display: inline-flex;
`;

export const ProfileImage = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 99px;

  object-fit: cover;

  ${({ theme }) => theme.screenSize.desktop} {
    width: 56px;
    height: 56px;
  }
`;

export const OnlineDot = styled.div`
  position: absolute;

  top: 1px;
  right: 1px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 3px;
  border-radius: 8px;

  width: 16px;
  height: 16px;

  border: 3px solid ${({ theme }) => theme.color.bg1};
  background-color: ${({ theme }) => theme.color.accentH1};
`;

export const NameWrap = styled.div`
  width: calc(100% - 24px);
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 8px;

  text-align: center;

  ${({ theme }) => theme.screenSize.desktop} {
    text-align: start;
    flex: 1;
  }
`;

export const Name = styled.span`
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 13px;
  font-weight: 700;

  ${({ theme }) => theme.screenSize.desktop} {
    font-size: 15px;

    white-space: normal;

    display: -webkit-box;
    display: box;
    -webkit-line-clamp: 2;

    line-clamp: 2;
    -webkit-box-orient: vertical;
    box-orient: vertical;
  }
`;

export const Time = styled.time`
  font-size: 13px;
  font-weight: 400;

  color: ${({ theme }) => theme.color.content10};

  ${({ theme }) => theme.screenSize.tablet} {
    display: none;
  }
`;

export const ActionButton = styled(GenericButton)`
  ${({ theme }) => theme.screenSize.tablet} {
    width: calc(100% - 24px);
  }
`;
